function formatPrice(currency, value) {
  return Intl.NumberFormat('en-US', {
    currency,
    minimumFractionDigits: 2,
    style: 'currency',
  }).format(value);
}

export default formatPrice;
